import { auth } from "firebase";
import React, { PureComponent } from "react";
import {
  Text,
  Dimensions,
  Image,
  StyleSheet,
  View,
  TouchableOpacity,
} from "react-native";

import SwiperFlatList from "react-native-swiper-flatlist";
import NewPage from "./NewPage";
import * as firebase from "firebase";
import stocks from "../stocks.json";
import stockTickers from "../stockTickers.json";
import Carousel, { Pagination } from "react-native-snap-carousel";
import SwitchingStockCards from "./SwitchingStockCards";

import { Button } from "react-native-elements";
import { Platform } from "react-native";
const SLIDER_WIDTH = Dimensions.get("window").width;
const ITEM_WIDTH = Math.round(SLIDER_WIDTH * 0.9);
const ITEM_HEIGHT = Dimensions.get("window").height * 0.8;
export default class App extends PureComponent {
  state = {
    stockList: [
      // {
      //   stock1: { symbol: "TSLA", name: "Tesla" },
      //   stock2: { symbol: "IBM", name: "IBM" },
      //   date: "16-11-2020",
      // },
      // {
      //   stock1: { symbol: "MSFT", name: "Microsoft" },
      //   stock2: { symbol: "", name: "" },
      //   date: "17-11-2020",
      // },
      // {
      //   stock1: { symbol: "AAPL", name: "Apple" },
      //   stock2: { symbol: "", name: "" },
      //   date: "18-11-2020",
      // },
      // {
      //   stock1: { symbol: "AMZN", name: "Amazon" },
      //   stock2: { symbol: "", name: "" },
      //   date: "19-11-2020",
      // },
      // {
      //   stock1: { symbol: "COST", name: "Costco" },
      //   stock2: { symbol: "", name: "" },
      //   date: "20-11-2020",
      // },
    ],
    readyToSubmit: false,
    index: 0,
  };
  componentDidMount() {
    this.getEntriesForThisIndustry(this.props.route.params.name);
  }

  switchOtherStockCard = (stockType) => {
    let idx = this.state.index;
    let stockList = [...this.state.stockList];

    SwitchingStockCards(stockType, stockList, idx);

    this.setState({
      stockList: stockList,
    });
  };

  submitBracket = () => {
    firebase
      .database()
      .ref(
        "userPicks/" +
          auth().currentUser.uid +
          "/" +
          this.state.stockList[0].date
      )
      .update({
        [this.props.route.params.name]: this.state.stockList,
      });
    this.props.navigation.push("Home");
  };
  getPreviousMonday = () => {
    var prevMonday = new Date();
    prevMonday.setDate(prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7));
    const getStringFormatOfDate = (date) => {
      var dd = String(date.getDate()).padStart(2, "0");
      var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = date.getFullYear();

      let strDate = dd + "-" + mm + "-" + yyyy;
      return strDate;
    };
    return getStringFormatOfDate(prevMonday);
  };
  getEntriesForThisIndustry = (industryName) => {
    firebase
      .database()
      .ref("entries/" + this.getPreviousMonday() + "/" + industryName)
      .once("value")
      .then((snapshot) => {
        const highscore = snapshot.val();
        this.setState({
          stockList: highscore,
        });
        return highscore;
      });
  };

  checkIfReadyToSubmit = () => {
    let stockList = [...this.state.stockList];
    return !stockList
      .map((stockObj) => {
        return [
          stockObj["stock1"]["symbol"] === "",
          stockObj["stock2"]["symbol"] === "",
        ];
      })
      .some((boolObj) => boolObj[0] === true || boolObj[1] === true);
  };

  onChangeIndex = (index) => {
    this.setState({ index: index });

    if (index === 4) {
      if (this.checkIfReadyToSubmit()) {
        //last one has to be selected as well
        this.setState({ readyToSubmit: true });
      }
    }
  };
  _renderItem = ({ item, index }) => {
    return (
      <View
        // style={[styles.child, { backgroundColor: "#011936" }]}
        style={{
          width: ITEM_WIDTH,
          height: ITEM_HEIGHT,
        }}
      >
        {/* <Button title={"goto next"} onPress={()=>{
            this.setState({index:this.state.index+1})

          }}/> */}
        <NewPage
          stock1={item["stock1"]}
          stock2={item["stock2"]}
          switchOtherStockCard={this.switchOtherStockCard}
          date={item["date"]}
          readyToSubmit={this.state.readyToSubmit}
          submitBracket={this.submitBracket}
        />
      </View>
    );
  };
  get pagination() {
    const { stockList, index } = this.state;
    return (
      <Pagination
        dotsLength={stockList.length}
        activeDotIndex={index}
        dotStyle={{
          width: 10,
          height: 10,
          borderRadius: 5,
          marginHorizontal: 8,
          backgroundColor: "rgba(255, 255, 255, 0.92)",
        }}
        inactiveDotStyle={{}}
        inactiveDotOpacity={0.4}
        inactiveDotScale={0.6}
      />
    );
  }

  render() {
    return (
      <View>

        {Platform.OS==="web"?
         <View
         style={{
           flexDirection: "row-reverse",
         }}
       >
         <View
           style={{
             flex: 1,
           }}
         >
           <Button
             title={"➡"}
             type="outline"
             onPress={() => {
               this._carousel.snapToNext();
             }}
           />
         </View>
         <View
           style={{
             flex: 1,
           }}
         >
           <Button
             type="outline"
             title={"⬅"}
             onPress={() => {
               this._carousel.snapToPrev();
             }}
           />
         </View>
       </View>:null
      }
       

        <Carousel
          ref={(c) => {
            this._carousel = c;
          }}
          data={this.state.stockList}
          renderItem={this._renderItem}
          sliderWidth={SLIDER_WIDTH}
          itemWidth={ITEM_WIDTH}
          // removeClippedSubviews={false}
          onSnapToItem={(index) => {
            this.onChangeIndex(index);
          }}
        />
        {this.pagination}

        {/* <SwiperFlatList
          ref={(ref) => {
            this.flatListRef = ref;
          }}
          getCurrentIndex={this.getCurrentIndex}
          onChangeIndex={this.onChangeIndex}
          data={this.state.stockList}
          renderItem={this._renderItem}
          index={0}
          showPagination
        /> */}
      </View>
    );
  }
}

export const { width, height } = Dimensions.get("window");

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
  },
  child: {
    height: height,
    width,
  },
  text: {
    fontSize: width * 0.5,
  },
});
